import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const STATUS_STYLES = {
  ROLLING: "text-brand border-brand/30 bg-brand/10",
  OPEN: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  "CLOSING SOON": "text-amber-400 border-amber-500/30 bg-amber-500/10",
  CLOSED: "text-rose-400 border-rose-500/30 bg-rose-500/10",
};

export default function FellowshipCard({ item, index }) {
  const statusClass = STATUS_STYLES[item.status] || STATUS_STYLES.ROLLING;

  return (
    <div
      className="animate-row group flex gap-4 border-b border-border/60 py-5"
      style={{ animationDelay: `${Math.min(index, 12) * 20}ms` }}
    >
      {/* Logo */}
      <Link to={`/o/${item.id}`} className="shrink-0">
        <Logo logoUrl={item.logoUrl} domain={item.domain} title={item.title} />
      </Link>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <Link
            to={`/o/${item.id}`}
            className="text-[15px] font-semibold text-foreground underline-offset-2 hover:underline"
          >
            {item.title}
          </Link>
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] text-muted-foreground hover:text-foreground"
          >
            {item.domain}
          </a>
          <span
            className={`rounded border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${statusClass}`}
          >
            {item.status}
          </span>
        </div>

        <p className="mt-1.5 text-[13.5px] leading-relaxed text-muted-foreground">
          {item.description}
        </p>

        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-[12.5px]">
          <span className="text-foreground/80">{item.category}</span>
          <span className="text-muted-foreground/50">&middot;</span>
          <span className="text-foreground/80">{item.region}</span>
          <span className="text-muted-foreground/50">&middot;</span>
          <span className="text-foreground/80">{item.org}</span>
          <span className="ml-1 flex flex-wrap gap-x-2">
            {item.tags.map((t) => (
              <span key={t} className="text-muted-foreground/70">
                {t}
              </span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
}
